export default __webpack_public_path__ + "static/media/increase.7521c705.svg";